export default "__VITE_ASSET__DzCVbYH0__"